import { Suspense, lazy } from 'react';

const Resources = lazy(() => import('../components/Resources/Resources'));

const ResourcesLazy: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <Resources />
    </Suspense>
  );
};

export default ResourcesLazy;
